__turbopack_context__.v({
  "breathe": "SlikerrLockup-module__OFFJPq__breathe",
  "lockup": "SlikerrLockup-module__OFFJPq__lockup",
  "lotus": "SlikerrLockup-module__OFFJPq__lotus",
  "wordmark": "SlikerrLockup-module__OFFJPq__wordmark",
});
